/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'pip-common.utils',
  'thd-overlay'
], function (
  $,
  Mustache,
  pip,
  pipCommonUtils,
  thdOverlay
) {


  var view = {
    selectors: {
      disclaimerLegalLink: '#legal_disclaimer_link',
      disclaimerContainer: '#disclaimer_content'
    },
    templates: {
      disclaimerMessage: $('#disclaimer_message').html(),
      disclaimerLegal: $('#disclaimer__legal-message').html(),
      disclaimerDefault: $('#disclaimer__default-message').html(),
      overlayTitle:$('#overlay_Title').html()
    },

    render: {
      disclaimerLegal: function renderDisclaimerLegal() {
        return Mustache.render(view.templates.disclaimerLegal, view)
      },
      overlayTitle: function renderOverlayTitle() {
        return Mustache.render(view.templates.overlayTitle, view)
      },
      disclaimerContent: function renderDisclaimerContent() {
        return Mustache.render(view.templates.disclaimerDefault, view)
      }
    },

    updateDOM: {
      disclaimerContent: function disclaimerContent() {
        $(view.selectors.disclaimerContainer).html(view.render.disclaimerContent)
      }
    },

    professionalOverLay: function professionalOverLay() {
      var overlayContent = document.createElement('div');
      overlayContent.innerHTML = view.render.disclaimerLegal();

      var professionalOverlay = new thdOverlay(
        {
          speed: '30ms',
          useContent: true,
          channel: pip.platform.toLowerCase() === 'mobile' ? 'mobile' : 'desktop',
          header: true,
          title:  pip.platform.toLowerCase() === 'mobile' ? view.render.overlayTitle():'Legal Disclaimer',
          htmlNode: overlayContent
        });

      $(window.document).off('.professional');
      $(window.document).on('click.professional', view.selectors.disclaimerLegalLink, function (e) {
        e.preventDefault();
        //hacky way to handle thd overlay border until THD overlay provide the fix
        $('#professionalOverlayTitle').parent().addClass('title-border');
        professionalOverlay.open();
      });
    },

    shouldDisplayProfessionalDisclaimer: function shouldDisplayProfessionalDisclaimer() {
      return !! (pipCommonUtils.deepGet(pip.products.primary, 'data.info.forProfessionalUseOnly')
        && pip.features.disclaimerMessageTypeEnabled);
    },

    init: function init() {
       if(view.shouldDisplayProfessionalDisclaimer()) {
          view.updateDOM.disclaimerContent();
          view.professionalOverLay();
       }
    }
  };

  return {
    init: function init() {
      view.init()
    },
    view: view
  }
});

}.call(window));